import moment from 'moment';
import Actions from 'webapp/actions/actions';
import LocationHelper from 'webapp/helpers/location_helper';
import { isProxyHarBackend } from '../../../helpers/application_helper';

const CLIENT_IDS = {
  prod: '4iapgkngm6qc6bnjft5fql42ka',
  qa: '7qduhaomfpqcnhmumid9p1cncf',
  local: 'no-client-id',
  ci: '1nbvjhu6qjsg1v4rvi3umkm0vd',
};

let coreAuthUris = {
  prod: 'auth.concertfin.com',
  qa: 'auth.qa.concertfin.net',
  ci1: 'auth.cis.concertfin.net',
  ci2: 'auth.cis.concertfin.net',
  ci3: 'auth.cis.concertfin.net',
  ci4: 'auth.cis.concertfin.net',
  ci5: 'auth.cis.concertfin.net',
  ci6: 'auth.cis.concertfin.net',
  ci7: 'auth.cis.concertfin.net',
  ci8: 'auth.cis.concertfin.net',
  ci9: 'auth.cis.concertfin.net',
  ci0: 'auth.cis.concertfin.net',
  local: 'uw.local.concertfin.net/fake-cognito-auth/#',
};

// let alts = ['next', 'prev'];
//
// Object.keys(coreAuthUris).forEach((env) => {
//   alts.forEach((alt) => {
//     coreAuthUris[`${env}-${alt}`] = coreAuthUris[env];
//   });
// });

let AUTH_URIS = coreAuthUris;

class DecisioningAuth {
  constructor() {
    this.jdcsBaseUrl = LocationHelper.getUrlForSubdomain('jdcs');
    this.configureAuth();
  }

  get url() {
    return this.jdcsBaseUrl;
  }

  getCurrentUsername() {
    const { email } = this.quickRead(this.idToken);
    return email;
  }

  isLoggedIn() {
    return (
      !!this.idToken && this.idToken.split('.').length === 3 && this.quickRead(this.idToken).exp > Date.now() / 1000
    );
  }

  configureAuth() {
    if (this.isLoggedIn()) {
      if (this.userHasNoGroups()) {
        Actions.setRoute('/pending-cognito-auth');
        return Actions.setView({ page: 'pendingCognitoAuth' });
      }
      this.doOneTimeRedirect();
      return this;
    }
    let { access_token, id_token } = this.readurl();
    if (id_token) {
      this.idToken = id_token;
    }
    if (access_token) {
      this.accessToken = access_token;
    }

    if (!this.isLoggedIn()) {
      return this.onAuthError();
    }

    if (this.userHasNoGroups()) {
      Actions.setRoute('/pending-cognito-auth');
      return Actions.setView({ page: 'pendingCognitoAuth' });
    }

    this.doOneTimeRedirect();

    return this;
  }

  userHasNoGroups() {
    let quickReadToken = this.quickRead(this.idToken);
    return (
      !quickReadToken['cognito:groups'] ||
      !Array.isArray(quickReadToken['cognito:groups']) ||
      quickReadToken['cognito:groups'].length === 0 ||
      (quickReadToken['cognito:groups'] || []).every((group) => {
        return !['underwriter', 'admin', 'readonly'].includes(group);
      })
    );
  }

  readurl() {
    let { access_token, token_type, expires_in, id_token } = window.location.pathname
      .substr(window.location.pathname.lastIndexOf('/') + 1)
      .split('&')
      .reduce((acc, v) => {
        let [key, value] = v.split('=');
        acc[key] = value;
        return acc;
      }, {});
    console.log('readurl', window.location.href, { access_token, token_type, expires_in, id_token });
    return { access_token, token_type, expires_in, id_token };
  }

  get oneTimeRedirect() {
    return window.localStorage.getItem('oneTimeRedirect');
  }

  set oneTimeRedirect(val) {
    if (val && val.includes('cognito')) {
      this.storeDefaultRedirect();
    } else {
      this.setLocalStorage('oneTimeRedirect', val);
    }
  }

  get accessToken() {
    return window.localStorage.getItem('switchCognitoAccessToken');
  }

  set accessToken(val) {
    this.setLocalStorage('switchCognitoAccessToken', val);
  }

  get idToken() {
    return window.localStorage.getItem('switchCognitoIDToken');
  }

  set idToken(val) {
    const expiresDate = moment()
      .add(Number(val ? 600000 : -1000), 'seconds')
      .toDate()
      .toUTCString();
    document.cookie = `cognitotoken=${val};expires=${expiresDate};path=/;domain=${LocationHelper.getCookieHost()}`;
    this.setLocalStorage('switchCognitoIDToken', val);
  }

  setLocalStorage(key, value) {
    if (key && (value || value === null)) {
      window.localStorage.setItem(key, value === null ? '' : value);
    }
  }

  quickRead(jwt) {
    try {
      return JSON.parse(atob(jwt.split('.')[1]));
    } catch (e) {
      return {};
    }
    // if we had the pipeline operator this would be jwt |> split`.` |> atob |> JSON.parse
  }

  async onAuthError(response) {
    try {
      if (response) {
        await response.text();
      }
    } catch (e) {}

    let envDomain = LocationHelper.getEnvByDomain();

    let isLocal = LocationHelper.isLocalStack();
    let protocol = LocationHelper.getProtocol();

    let clientId = CLIENT_IDS[envDomain] || CLIENT_IDS.ci;

    let isHarBackend = await isProxyHarBackend();
    let authURI = AUTH_URIS[envDomain] || AUTH_URIS.local;
    if (isHarBackend) {
      authURI = (LocationHelper.getUrlForSubdomain('uw') + '/fake-cognito-auth/#').replace('https://', '');
    }
    console.log('authURI', authURI);
    let href = window.location.href;

    if (href.includes('error_description')) {
      Actions.setErrorMessages([href.match(/(error_description=)(.*)/)[2]]);
      return;
    }

    if (!this.idToken || (!href.includes('access_token') && !href.includes('id_token'))) {
      this.oneTimeRedirect = href;
      if (isLocal || isHarBackend) {
        this._redirectPage = `${protocol}://${authURI}`;
        return;
      }
      let redirectURI = `${LocationHelper.getUrlForSubdomain('uw')}/cognito-auth/`;
      this._redirectPage = `${protocol}://${authURI}/login?client_id=${clientId}&response_type=token&scope=phone+email+openid+profile&redirect_uri=${redirectURI}`;
      return;
    }
    this.doOneTimeRedirect(href);
  }

  storeDefaultRedirect() {
    this.oneTimeRedirect = '/admin/customers/decisions';
    return this;
  }

  doOneTimeRedirect() {
    if (this.oneTimeRedirect) {
      let tmp = this.oneTimeRedirect;
      this.oneTimeRedirect = null;

      if (tmp && !tmp.includes('cognito')) {
        this._redirectPage = tmp;
        return;
      }
      this._redirectPage = '/admin/customers/decisions';
    }
  }

  set _redirectPage(url) {
    if (localStorage.getItem('_XDEBUG') === 'true') {
      console.log('redirecting to: ' + url);
    }
    window.location.href = url;
  }
}

export default DecisioningAuth;
